import { MOSCOW_LABELS, MOSCOW_ORDER } from '../types';
import type { MoscowLevel } from '../types';

/**
 * THE RELEASE-PRIORITY NUDGE — #6.
 *
 * A card's MoSCoW level is set out of sight, in the opened card, so the roll-up
 * in the requirements document sat half-empty. This asks the question at the
 * moment the decision is actually made: when a card is pulled into a phase or
 * added to a sprint it is being committed to a release, so a slim strip appears
 * on it offering the four levels as one-click buttons. A NUDGE, NEVER A GATE —
 * one click sets it, "Not now" dismisses it, and the placement is untouched
 * either way (Vinnie, 16 September, approved mockup dev-preview/moscow-nudge.html).
 *
 * It is shown ONLY on a just-placed card that has no level yet — the store holds
 * the set of ids to nudge (see `moscowNudge`), so the Plan and the Sprints screen
 * render the same thing from one source and can never drift. The words are the
 * card's own plain release levels (no acronym on screen).
 */
export default function MoscowNudge({
  onPick,
  onDismiss,
}: {
  onPick: (level: MoscowLevel) => void;
  onDismiss: () => void;
}) {
  return (
    <div className="moscow-nudge" role="group" aria-label="How essential is this for the release?">
      <span className="mn-lead">How essential is this for the release?</span>
      <span className="mn-opts">
        {MOSCOW_ORDER.map((level) => (
          <button
            key={level}
            type="button"
            className={`mn-lvl is-${level}`}
            onClick={() => onPick(level)}
          >
            {MOSCOW_LABELS[level]}
          </button>
        ))}
      </span>
      <button type="button" className="mn-skip" onClick={onDismiss}>
        Not now
      </button>
    </div>
  );
}
